(() => {
  const SELECTORS = {
    wrapper: '.ibkul-prints-slider-wrapper',
    slider: '[data-ibkul-print-slider]',
    prev: '[data-ibkul-print-prev]',
    next: '[data-ibkul-print-next]',
    item: '.ibkul-print-item'
  };

  const getParts = (wrapper) => ({
    slider: wrapper.querySelector(SELECTORS.slider),
    prevButton: wrapper.querySelector(SELECTORS.prev),
    nextButton: wrapper.querySelector(SELECTORS.next)
  });

  const getScrollAmount = (slider) => {
    const firstItem = slider.querySelector(SELECTORS.item);
    if (!firstItem) return slider.clientWidth * 0.8;

    const styles = window.getComputedStyle(slider);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;

    return firstItem.getBoundingClientRect().width + gap;
  };

  const updateButtons = (wrapper) => {
    const { slider, prevButton, nextButton } = getParts(wrapper);
    if (!slider) return;

    // Skip while hidden (e.g. closed menu) so buttons are not locked as disabled
    if (slider.clientWidth === 0) return;

    const maxScroll = slider.scrollWidth - slider.clientWidth;
    const currentScroll = slider.scrollLeft;

    if (prevButton) prevButton.disabled = currentScroll <= 2;
    if (nextButton) nextButton.disabled = currentScroll >= maxScroll - 2;
  };

  const initWrapper = (wrapper) => {
    if (wrapper.dataset.ibkulSliderReady === 'true') return;

    const { slider } = getParts(wrapper);
    if (!slider) return;

    wrapper.dataset.ibkulSliderReady = 'true';

    slider.addEventListener('scroll', () => updateButtons(wrapper), { passive: true });

    // Re-check buttons whenever the slider becomes visible or changes size
    if ('ResizeObserver' in window) {
      new ResizeObserver(() => updateButtons(wrapper)).observe(slider);
    } else {
      window.addEventListener('resize', () => updateButtons(wrapper));
    }

    updateButtons(wrapper);
  };

  const initAll = () => {
    document.querySelectorAll(SELECTORS.wrapper).forEach(initWrapper);
  };

  // Delegated click handler: works even if the menu markup is rendered or cloned later
  document.addEventListener('click', (event) => {
    const button = event.target.closest(`${SELECTORS.prev}, ${SELECTORS.next}`);
    if (!button) return;

    const wrapper = button.closest(SELECTORS.wrapper);
    if (!wrapper) return;

    const { slider } = getParts(wrapper);
    if (!slider) return;

    // Prevent the menu from treating this click as a link click or close action
    event.preventDefault();
    event.stopPropagation();

    initWrapper(wrapper);

    const direction = button.matches(SELECTORS.prev) ? -1 : 1;
    slider.scrollBy({ left: direction * getScrollAmount(slider), behavior: 'smooth' });
  }, true);

  const start = () => {
    initAll();

    // Initialize sliders that are added to the page after load (lazy menus, drawers)
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        initAll();
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();